import manifest from '../../../../config/demo/menu-items.json';

export interface MenuNode {
  id?: string;
  name?: string;
  label?: string;
  route?: string | null;
  disabled?: boolean;
  items?: MenuNode[];
}
export interface MenuFlags { enabled?: boolean | null; show?: boolean | null }
export type MenuOverrides = Record<string, MenuFlags>;

/** Resource identities survive label edits. New/custom resources must be added to the manifest. */
export function resourceMenuId(resourceId: number): string {
  return manifest.find(entry => 'resourceId' in entry && entry.resourceId === resourceId)?.id ?? `/Resources/${resourceId}`;
}

/** Visibility never removes an access grant. A disabled owner removes only its own grant. */
export function projectMenu<T extends MenuNode>(nodes: T[], overrides: MenuOverrides) {
  const routes = new Set<string>();
  const visibleRoutes: string[] = [];
  function visit(node: MenuNode, parentEnabled: boolean, parentShown: boolean): MenuNode | undefined {
    const flags = node.id ? overrides[node.id] : undefined;
    const enabled = parentEnabled && !node.disabled && flags?.enabled !== false;
    const shown = parentShown && flags?.show !== false;
    if (enabled && node.route && node.route !== '#') {
      routes.add(node.route);
      if (shown) visibleRoutes.push(node.route);
    }
    const children = node.items?.map(child => visit(child, enabled, shown)).filter((item): item is MenuNode => !!item);
    if (!shown || (node.items?.length && !children?.length && !node.route)) return undefined;
    return { ...node, ...(enabled ? {} : { disabled: true }), ...(children ? { items: children } : {}) };
  }
  const visible = nodes.map(node => visit(node, true, true)).filter((item): item is MenuNode => !!item) as T[];
  return { sidenav: visible, allowedRoutes: [...routes], landingRoute: visibleRoutes[0] ?? '/unauthorized' };
}
